import { Fragment, useId } from 'react'
import { Tooltip } from 'react-tooltip';
import { twMerge } from 'tailwind-merge';

interface TextWithTooltipProps {
  content: string;
  maxLength: number;
  className?: string;
  tooltipClassName?: string
}

export default function TextWithTooltip({
  content,
  maxLength = 100,
  className,
  tooltipClassName
}: TextWithTooltipProps) {
  const uniqueId = useId();

  const fullText = content?.toString() || '';

  const isTruncated = fullText.length > maxLength

  let shortText = fullText;
  if(isTruncated) {
    const slicedText = fullText.slice(0, maxLength);
    const lastSpaceIndex = slicedText.lastIndexOf(' ');
    
    const cutIndex = lastSpaceIndex > 0 ? lastSpaceIndex : maxLength;
    shortText = `${fullText.slice(0, cutIndex)}...`;
  }

  return (
    <Fragment>
      <p
        data-tooltip-id={uniqueId}
        data-tooltip-place="top"
        data-tooltip-content={fullText}
        className={twMerge("break-words cursor-default", className)}
        // className={twMerge("text-sm text-ellipsis line-clamp-2 cursor-default", className)}
      >
        {shortText || '--'}
      </p>
      {fullText.length > maxLength && (
        <Tooltip
          id={uniqueId}
          className={twMerge("z-50 max-w-[500px] whitespace-pre-wrap break-words bg-[#1f1f1f] p-4 border border-gray-700 text-white-900 text-sm", tooltipClassName)}
        />
      )}
    </Fragment>
  )
}
